/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { AppPermissionsEnum } from './AppPermissionsEnum';
import {
    AppPermissionsEnumFromJSON,
    AppPermissionsEnumFromJSONTyped,
    AppPermissionsEnumToJSON,
} from './AppPermissionsEnum';
import type { PermissionDtoParent } from './PermissionDtoParent';
import {
    PermissionDtoParentFromJSON,
    PermissionDtoParentFromJSONTyped,
    PermissionDtoParentToJSON,
} from './PermissionDtoParent';

/**
 * 
 * @export
 * @interface PermissionDto
 */
export interface PermissionDto {
    /**
     * 
     * @type {AppPermissionsEnum}
     * @memberof PermissionDto
     */
    id?: AppPermissionsEnum;
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    i18n?: string | null;
    /**
     * 
     * @type {PermissionDtoParent}
     * @memberof PermissionDto
     */
    parent?: PermissionDtoParent | null;
    /**
     * 
     * @type {PermissionDtoParent}
     * @memberof PermissionDto
     */
    root?: PermissionDtoParent | null;
    /**
     * 
     * @type {PermissionDtoParent}
     * @memberof PermissionDto
     */
    group?: PermissionDtoParent | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    category?: string | null;
    /**
     * 
     * @type {Array<AppPermissionsEnum>}
     * @memberof PermissionDto
     */
    children?: Array<AppPermissionsEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionDto
     */
    $type?: PermissionDtoTypeEnum;
}


/**
 * @export
 */
export const PermissionDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationPermissionsDtoPermissionDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Permissions.Dto.PermissionDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type PermissionDtoTypeEnum = typeof PermissionDtoTypeEnum[keyof typeof PermissionDtoTypeEnum];



/**
 * Check if a given object implements the PermissionDto interface.
 */
export function instanceOfPermissionDto(value?: unknown): value is PermissionDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(PermissionDtoTypeEnum)[0];
}

export function PermissionDtoFromJSON(json: any): PermissionDto {
    return PermissionDtoFromJSONTyped(json, false);
}

export function PermissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : AppPermissionsEnumFromJSON(json['id']),
        'i18n': json['i18n'] == null ? undefined : json['i18n'],
        'parent': json['parent'] == null ? undefined : PermissionDtoParentFromJSON(json['parent']),
        'root': json['root'] == null ? undefined : PermissionDtoParentFromJSON(json['root']),
        'group': json['group'] == null ? undefined : PermissionDtoParentFromJSON(json['group']),
        'category': json['category'] == null ? undefined : json['category'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(AppPermissionsEnumFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function PermissionDtoToJSON(value?: PermissionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': AppPermissionsEnumToJSON(value['id']),
        'i18n': value['i18n'],
        'parent': PermissionDtoParentToJSON(value['parent']),
        'root': PermissionDtoParentToJSON(value['root']),
        'group': PermissionDtoParentToJSON(value['group']),
        'category': value['category'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(AppPermissionsEnumToJSON)),
        '$type': value['$type'],
    });
}

